// extracted by mini-css-extract-plugin
module.exports = {"dataChart_m":"userMonitor_mobile_dataChart_m__2oR8T","dataGrid_m":"userMonitor_mobile_dataGrid_m__2t4ap"};